import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import './LegalPage.css';

const PrivacyPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="legal-page">
      <Navbar />
      <div className="legal-page__hero">
        <div className="container">
          <span className="section-label">Legal</span>
          <h1 className="legal-page__title">Política de Privacidad</h1>
          <p className="legal-page__subtitle">Última actualización: junio 2025</p>
        </div>
      </div>

      <div className="container legal-page__body">
        <div className="legal-page__content">

          <section className="legal-section">
            <h2>1. Responsable del tratamiento</h2>
            <p>
              <strong>Consuprog</strong> (en adelante "la Empresa"), con domicilio en Tegucigalpa, Honduras,
              es responsable del tratamiento de los datos personales recopilados a través del sitio web
              <strong> consuprog.com</strong>.
            </p>
            <p>Contacto: <a href="mailto:GerenciaConsuprog@consuprog.com">GerenciaConsuprog@consuprog.com</a></p>
          </section>

          <section className="legal-section">
            <h2>2. Datos que recopilamos</h2>
            <p>A través del formulario de contacto recopilamos:</p>
            <ul>
              <li>Nombre completo</li>
              <li>Nombre de empresa (opcional)</li>
              <li>Número de teléfono</li>
              <li>Correo electrónico</li>
              <li>Tipo de proyecto de interés</li>
              <li>Descripción del proyecto</li>
            </ul>
            <p>No recopilamos datos sensibles, datos de pago ni información de menores de edad.</p>
          </section>

          <section className="legal-section">
            <h2>3. Finalidad del tratamiento</h2>
            <p>Los datos recopilados se utilizan exclusivamente para:</p>
            <ul>
              <li>Responder a su consulta o solicitud de cotización</li>
              <li>Contactarle para brindar información sobre nuestros servicios</li>
              <li>Dar seguimiento a proyectos de interés</li>
            </ul>
            <p>No utilizamos sus datos para envío de publicidad masiva ni los compartimos con terceros sin su consentimiento.</p>
          </section>

          <section className="legal-section">
            <h2>4. Conservación de datos</h2>
            <p>
              Sus datos se conservan únicamente durante el tiempo necesario para atender su consulta y el
              período legal requerido en Honduras. Una vez cumplida la finalidad, los datos son eliminados
              de manera segura.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Compartición de datos</h2>
            <p>
              Consuprog no vende, alquila ni cede sus datos personales a terceros. Los datos pueden ser
              procesados por proveedores de servicios tecnológicos (como servicios de correo electrónico)
              únicamente para gestionar las comunicaciones, bajo estrictas condiciones de confidencialidad.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Sus derechos</h2>
            <p>Usted tiene derecho a:</p>
            <ul>
              <li>Acceder a los datos que tenemos sobre usted</li>
              <li>Solicitar la corrección de datos inexactos</li>
              <li>Solicitar la eliminación de sus datos</li>
              <li>Retirar su consentimiento en cualquier momento</li>
            </ul>
            <p>
              Para ejercer cualquiera de estos derechos, contáctenos en{' '}
              <a href="mailto:GerenciaConsuprog@consuprog.com">GerenciaConsuprog@consuprog.com</a>.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Seguridad</h2>
            <p>
              Adoptamos medidas técnicas y organizativas para proteger sus datos contra acceso no
              autorizado, pérdida o divulgación. Sin embargo, ninguna transmisión por internet es
              100% segura.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Cambios a esta política</h2>
            <p>
              Nos reservamos el derecho de actualizar esta Política de Privacidad. Los cambios serán
              publicados en esta página con la fecha de actualización correspondiente.
            </p>
          </section>

          <div className="legal-page__back">
            <Link to="/" className="btn-back">← Volver al inicio</Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
